import { render, staticRenderFns } from "./ProformCategoryTable.vue?vue&type=template&id=29eda722&scoped=true"
import script from "./ProformCategoryTable.vue?vue&type=script&lang=js"
export * from "./ProformCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eda722",
  null
  
)

export default component.exports